<template>
  <module-page v-bind="pageParams" :loading="!!loadingProduct">
    <iframe
      v-show="!iframeError"
      ref="iframe"
      class="my-enterprise__iframe"
      :src="url"
    />
    <empty-state-card
      v-if="iframeError"
      :message="enums.responses.error"
      icon="alert"
    ></empty-state-card>
  </module-page>
</template>

<script>
import { APP, IFRAME } from '../../utils/constants';
import ModulePage from '@/components/layout/Page';
import EmptyStateCard from '@/components/layout/EmptyStateCard.vue';
export default {
  name: 'myEnterprise',
  components: {
    ModulePage,
    EmptyStateCard,
  },  
  computed: {
    url(){
      return this.$store.getters[IFRAME.GET_MY_ENTERPRISE_PAGE_URL];
    }
  },
  data() {
    return {
      iframeError: false,
      loadingProduct: null,
      pageParams: this.$store.getters[APP.PAGES].myEnterprise,
    };
  }
};
</script>
<style lang="scss" scoped>
@import '../../assets/scss/breakpoint';
.my-enterprise {
  &__iframe {
    width: 100%;
    height: 100%;
    min-width: 1021px;
    min-height: 3200px;
    border: none;
    margin-bottom: 10px;
    @include breakpoint(mobile) {
      min-width: initial;
      min-height: 2500px;
      max-width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/product/MyEnterprise.vue